import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";

const STORAGE_KEY = "caileve_cookie_notice_accepted_v1";

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const accepted = window.localStorage.getItem(STORAGE_KEY);
      if (!accepted) setVisible(true);
    } catch {
      // storage unavailable — silently skip
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie and data notice"
      className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-50 shadow-[0_10px_40px_-12px_rgba(30,22,36,0.25)]"
      style={{
        backgroundColor: "var(--caileve-soft)",
        border: "1px solid #D9C9DE",
      }}
    >
      <div className="px-5 py-4 sm:px-6 sm:py-5">
        <p
          className="leading-relaxed"
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            color: "var(--caileve-ink)",
            fontSize: "1.05rem",
          }}
        >
          Cailève uses essential cookies and securely stores your
          wardrobe data so that your collection appears the same on every
          visit. We never share your data with third parties. See our{" "}
          <Link
            to="/privacy"
            className="underline underline-offset-2"
            style={{ color: "var(--caileve-lilac)" }}
          >
            Privacy Policy
          </Link>
          .
        </p>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            onClick={accept}
            className="px-5 h-9 rounded-full transition-opacity hover:opacity-90"
            style={{
              backgroundColor: "var(--caileve-lilac)",
              color: "var(--caileve-bg)",
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: "0.95rem",
              letterSpacing: "0.05em",
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}